import type { JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { useIsOdesaTemplate } from '~/utilities/useIsOdesaTemplate';

const cssClasses = cva('min-w-0 flex-1', {
  variants: {
    isOdesa: {
      true: 'odesa-article-main',
      false: '',
    },
  },
});

export default component$((): JSX.Element => {
  const isOdesa = useIsOdesaTemplate();
  return (
    <main class={cssClasses({ isOdesa })}>
      <div class='viewablity-block'>
        <Slot />
      </div>
    </main>
  );
});
